import { reportsPeriodStore } from '../model/reportsPeriodStore'
import {
	getReportPeriodLabel,
	getReportPeriodTitlePhrase,
	REPORT_PERIODS,
} from '../utils/reportsPeriods'

/**
 * Shared applied + draft reporting-period controls for Reports pages.
 */
export const useReportsPeriodControls = () => {
	const store = reportsPeriodStore
	const appliedArgs = store.appliedFetchArgs

	return {
		periods: REPORT_PERIODS,
		selectedPeriod: store.selectedType,
		draftFrom: store.draftFrom,
		draftTo: store.draftTo,
		canApplyCustom: store.canApplyCustom,
		customRangeInvalid: store.isDraftInvalid,
		appliedPeriod: appliedArgs.period,
		appliedCustomFrom: appliedArgs.customFrom,
		appliedCustomTo: appliedArgs.customTo,
		periodLabel: getReportPeriodLabel(appliedArgs.period, {
			customFrom: appliedArgs.customFrom,
			customTo: appliedArgs.customTo,
		}),
		periodTitlePhrase: getReportPeriodTitlePhrase(appliedArgs.period, {
			customFrom: appliedArgs.customFrom,
			customTo: appliedArgs.customTo,
		}),
		triggerLabel: getReportPeriodLabel(store.selectedType, {
			customFrom: store.isCustomSelected ? store.draftFrom : appliedArgs.customFrom,
			customTo: store.isCustomSelected ? store.draftTo : appliedArgs.customTo,
		}),
		onPeriodChange: store.selectPeriod,
		onCustomFromChange: store.setDraftFrom,
		onCustomToChange: store.setDraftTo,
		onApplyCustom: store.applyCustom,
	}
}
